<template>
    <div class="lo main">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data: function(){
            
            return {}
        },
    }
</script>

<style scoped lang="scss">
    .lo.main {

    }
</style>
